export enum CoverageArea {
  BOTTOM = 'BOTTOM',
  TOP = 'TOP',
}
